'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsubscribedUserNav = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SellPageLinks = require('../NavItems/SellPageLinks');

var _LiveProductLinks = require('../NavItems/LiveProductLinks');

var _GoProductLinks = require('../NavItems/GoProductLinks');

var _LoginLink = require('../NavItems/LoginLink');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnsubscribedUserNav = exports.UnsubscribedUserNav = function UnsubscribedUserNav(_ref) {
  var isLivePage = _ref.isLivePage,
      isGoPage = _ref.isGoPage,
      isLoggedIn = _ref.isLoggedIn;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    isLivePage && _react2.default.createElement(_LiveProductLinks.LiveProductLinks, null),
    isGoPage && _react2.default.createElement(_GoProductLinks.GoProductLinks, null),
    !isLivePage && !isGoPage && _react2.default.createElement(_SellPageLinks.SellPageLinks, null),
    !isLoggedIn && !isGoPage && _react2.default.createElement(_LoginLink.LoginLink, null)
  );
};

UnsubscribedUserNav.propTypes = {
  isLoggedIn: _propTypes2.default.bool,
  isLivePage: _propTypes2.default.bool,
  isGoPage: _propTypes2.default.bool
};